var sideNavAccordions = {};

sideNavAccordions.toggleCallback = function () {
    // reinit side nav scroll
    if (sideNavScroll.inst) {
        sideNavScroll.inst.setInitFns(true);
    };
};

sideNavAccordions.openCookieAccordions = function () {
    var c = logicjs.getCookie("NavAccordionExpandedList"),
        array = JSON.parse(c);

    for (var i = 0; i < array.length; i++) {
        for (var j = 0; j < sideNavAccordions.inst.accordions.length; j++) {
            var ctrl = $(sideNavAccordions.inst.accordions[j]).find(sideNavAccordions.inst.accordionCtrlTarget),
                attr = ctrl[0].getAttribute("data-tab-name");

            if (attr === array[i]) {
                sideNavAccordions.inst.setActiveAccordion($(sideNavAccordions.inst.accordions[j]), true);
            };
        };
    };
    sideNavScroll.inst.setInitFns(true);
};


